import { Box } from "@mui/material";
import * as React from "react";
import {
  Obstacle as ObstacleType,
  ObstacleType as ObstacleTypeType,
} from "../../../types";

type Props = ObstacleType & {
  feetToPixels: number;
};

export const OBSTACLE_STYLES = {
  [ObstacleTypeType.OBSTRUCTION]: {
    backgroundColor: "#d7d7d7",
  },
  [ObstacleTypeType.NO_TOW_AREA]: {
    backgroundColor: "transparent",
    outlineColor: "red",
    outlineWidth: "2px",
    outlineStyle: "dashed",
  },
  [ObstacleTypeType.UNOBSTRUCTIVE]: {
    backgroundColor: "#3c6ce990",
  },
  [ObstacleTypeType.CAUTION]: {
    backgroundColor: "#ECE81A90",
  },
};

export const Obstacle: React.FC<Props> = ({
  feetToPixels,
  x,
  y,
  type,
  width,
  depth,
}) => {
  // if it's a NO_TOW_AREA and it's touching a wall, we don't render it
  if (type === ObstacleTypeType.NO_TOW_AREA) {
    const isTouchingWall =
      (x <= 0 && y <= 0) || // Top-left corner
      (x + width >= 1 && y <= 0) || // Top-right corner
      (x <= 0 && y + depth >= 1) || // Bottom-left corner
      (x + width >= 1 && y + depth >= 1); // Bottom-right corner

    if (isTouchingWall) {
      return null;
    }
  }
  return (
    <Box
      data-type={`obstacle-${type}`}
      sx={{
        zIndex: type === ObstacleTypeType.OBSTRUCTION ? 2 : 1,
        position: "absolute",
        top: `${feetToPixels * y}px`,
        left: `${feetToPixels * x}px`,
        width: `${feetToPixels * width}px`,
        height: `${feetToPixels * depth}px`,
        ...OBSTACLE_STYLES[type],
      }}
    ></Box>
  );
};
